module.exports = __webpack_public_path__ + "img/avt1.3b182abb.9f70af34.png";